export default "__VITE_ASSET__BOuM13rV__"